import {StoreProvider} from 'lowkey-component';

import {ITrainingState} from '@services/types';
import {
  currentIdSaved,
  trainingDialogAppended,
  trainingDialogRemoved,
  TrainingModal,
} from '@store/trainingSlice';

export const createTrainingState = (): ITrainingState => {
  const store = StoreProvider.create();
  return {
    appendTrainingModal: (modal: TrainingModal) => {
      store.dispatch(trainingDialogAppended(modal));
      store.dispatch(currentIdSaved(modal.id));
    },
    removeTrainingModal: (id: string) => {
      store.dispatch(currentIdSaved(undefined));
      store.dispatch(trainingDialogRemoved(id));
    },
  };
};
